<template>
	<h2 class="title tal">{{ $t(terms.type) }}</h2>
	<div class="mh_50v" style="overflow-y: auto">
		<!--		<p v-html="terms.content"></p>-->
		<PrivacyPolicy1 v-if="terms.number === 1"></PrivacyPolicy1>
		<PrivacyPolicy2 v-if="terms.number === 2"></PrivacyPolicy2>
		<PrivacyPolicy3 v-if="terms.number === 3"></PrivacyPolicy3>
		<Agreement1 v-if="terms.number === 4"></Agreement1>
		<Guideline1 v-if="terms.number === 5"></Guideline1>
		<LegalIndication1 v-if="terms.number === 6"></LegalIndication1>
	</div>
	<div :class="[{ button_area_type01: mobile }, 'button_area']">
		<button class="button_primary" @click="$emit('close')">
			{{ $t('rtr_auth-register.cancel') }}
		</button>
		<button class="button_bg_blue" @click="agreeTerms">
			{{ $t('rtr_auth-register.agree') }}
		</button>
	</div>
</template>

<script>
import { isMobile } from '@/common/mobile';
import PrivacyPolicy1 from '@/components/Terms/PrivacyPolicy/PrivacyPolicy1';
import PrivacyPolicy2 from '@/components/Terms/PrivacyPolicy/PrivacyPolicy2';
import PrivacyPolicy3 from '@/components/Terms/PrivacyPolicy/PrivacyPolicy3';
import Agreement1 from '@/components/Terms/FranchiseAgreement/Agreement1';
import Guideline1 from '@/components/Terms/Guideline/Guideline1';
import LegalIndication1 from '@/components/Terms/LegalIndication/LegalIndication1';

export default {
	name: 'TermsContent',
	components: {
		PrivacyPolicy1,
		PrivacyPolicy2,
		PrivacyPolicy3,
		Agreement1,
		Guideline1,
		LegalIndication1,
	},
	emits: ['close', 'agreeTerms'],
	props: {
		terms: {
			type: Object,
		},
	},
	data() {
		return {
			mobile: isMobile(),
		};
	},
	methods: {
		agreeTerms() {
			this.$emit('agreeTerms', this.terms);
		},
	},
};
</script>
<style>
.modal_m pre {
	text-align: left;
}
pre {
	padding: 1em;
	width: 100%;
	height: auto;
	overflow: auto;
	font-family: inherit;
	background-color: #fff;
	word-break: normal !important;
	word-wrap: normal !important;
	white-space: pre-wrap !important;
}
</style>
